export default "__VITE_ASSET__qDC2QU23__"